import { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'w-[64em] animate-pulse rounded-md bg-neutral-900/10',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
